import GameFactory from "../../vendor_core/src/factories/GameFactory";
import CustomReelFrame from "./view/CustomReelFrame";
import CustomReelBacks from "./view/CustomReelBacks";
import CustomTotalWinningsPopup from "./view/CustomTotalWinningsPopup";
import ReelGroup from "../../vendor_core/core/src/views/ReelGroup";
import TestSubview from "./view/TestSubview";
import VOEReelGroup from "./view/VOEReelGroup";
import VOEWinSymbolsView from "./view/VOEWinSymbolsView";
import VOEAnticipation from "./view/VOEAnticipation";
import MSReelVerticalSpinBehaviour from "./spinners/MSReelVerticalSpinBehaviour";
import VOEUIView from './view/VOEUIView';
import BaseUI from "../../vendor_core/core/src/ui/BaseUI";
import ReelSymbol from "../../vendor_core/core/src/views/Symbol";
import VOEWinlinesView from "./view/VOEWinlinesView";
import AudioSequencer from "../../vendor_core/core/src/utils/AudioSequencer";
import IdleBackgroundMusicSequencer from "./sound/IdleBackgroundMusicSequencer";
import Reel from '../../vendor_core/core/src/views/Reel';
import MSSettings from './view/MSSettings';
import BaseSettings from '../../vendor_core/core/src/ui/BaseSettings';
import MYSymbolAnimation from "./view/MYSymbolAnimation";

/**
 * Factory for creating game specific objects
 */
class VOEGameFactory extends GameFactory {
    protected getTotalWinningsPopup() {
        return new CustomTotalWinningsPopup();
    }

    protected getAnticipation() {
        return new VOEAnticipation();
    }

    protected getWinSymbolsView() {
        return new VOEWinSymbolsView();
    }

    protected getWinlinesView() {
        return new VOEWinlinesView();
    }

    protected getReelGroup() {
        return new VOEReelGroup();
    }

    protected getReelBacks(reelGroup: ReelGroup) {
        return new CustomReelBacks(reelGroup);
    }

    protected getReelFrame() {
        return new CustomReelFrame();
    }

    protected getTestSubview() {
        return new TestSubview();
    }

    protected getUIView(): BaseUI {
        return new VOEUIView();
    }

    protected getSymbol() {
        return new ReelSymbol();
    }

    protected getSettings(): BaseSettings {
        return new  MSSettings();
    }

    protected getSymbolAnimation() {
        return new MYSymbolAnimation();
    }

    protected getIdleBackgroundMusicSequencer(): AudioSequencer {
        return new IdleBackgroundMusicSequencer();
    }

    protected getFreeSpinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new MSReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }

    protected getRespinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new MSReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }

    protected getSpinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new MSReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }

    // protected getSettings(): BaseSettings {
    //     return new VTWSettings();
    // }
}

export default VOEGameFactory;
